<template>
    <div class="step2-container">
        <div class="main-content-container no-scrollbar">
            <div id="jump1" class="content-header" :class="[(selectedAddonProducts.length > 0) ? 'cart' : '']">
                <img alt="start here" class="starburst lazyload" loading="lazy" src="https://cdn.shopify.com/s/files/1/1363/8433/files/start_here.svg?v=1732206158"/>
                <div>
                    <p class="title">Build a Gift Box</p>
                    <div class="sticky-image-container">
                        <p class="steps">
                            STEP 1 OF 3:
                            <span class="dot current">
                                <span class="selected"></span>
                            </span>
                            <span class="dot">
                                <span></span>
                            </span>
                            <span class="dot">
                                <span></span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div id="header-container" class="header-container" :class="[isSticking ? 'sticky' : '',(selectedAddonProducts.length > 0) ? 'cart' : '']">
                <div v-if="currentOccassionImage" class="placeholder-recommendations">
                    <div class="buttons-container">
                        <div v-if="bulkOpen" class="sort-block">
                            <p @click="() => {bulkOpen = false}" class="close">X</p>
                            <p><strong>Buying in bulk?</strong></p>
                            <p>Sort by high stock!</p>
                            <div class="arrow-t">
                                <div class="inner"></div>
                            </div>
                        </div>
                        <button class="happybox-button white border" :class=" totalCurrentFilters > 0 ? 'selected' : ''" @click="showFilters()">
                            <img v-if="totalCurrentFilters > 0" class="purple" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"/>
                            <img v-else class="normal" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"/>
                            Filter Products
                            <span v-if="totalCurrentFilters > 0">({{ totalCurrentFilters }})</span>
                        </button>
                        <button class="happybox-button white border" @click="showSort()"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/Group_4412.png?v=1722267051"/>Sort Products</button>
                    </div>
                    <div class="sticky-image-container">
                        <p class="steps">
                            STEP 1 OF 3: <span class="legend">Start adding gifts!</span>
                            <span class="dot current">
                                <span class="selected"></span>
                            </span>
                            <span class="dot">
                                <span></span>
                            </span>
                            <span class="dot">
                                <span></span>
                            </span>
                        </p>
                    </div>
                    <p  class="leave-builder" @click="leaveBuilder">
                        <span v-tooltip="'Save your selections for 24 hours. Inventory subject to availability'">
                            SAVE YOUR BOX
                        </span>
                        <img v-tooltip="'Save your selections for 24 hours. Inventory subject to availability'" src="https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart.svg?v=1722005665" alt="save cart">
                    </p>
                </div>
            </div>
            <div class="content-container no-scrollbar">
                <div class="filters-container">
                    <div class="sticky-filter">
                        <p class="title">Product Type</p>
                        <CategoriesFilter :categoriesArray="categories"/>
                    </div>
                </div>
                <div class="products-wrapper" :class="[(selectedAddonProducts.length > 0) ? 'big' : '']">
                    <ul v-if="!addonProducts || addonProducts.length == 0" class="products-container no-scrollbar">
                        <li v-for="n in 12" :key="n">
                            <AddonProductSkeleton v-for="n in 12" :key="n" />
                        </li>
                    </ul>
                    <ul v-else class="products-container no-scrollbar">
                        <p class="other-gifts" v-if="nonFilteredProducts.length > 0">{{breadcrumbText}}</p>
                        <li v-for="addonProduct in sortedProducts" :key="addonProduct.id">
                            <AddonProductNew 
                            @loadmodal="openModal($event)" 
                            :product="addonProduct" 
                            :cartProducts="selectedAddonProducts"
                            :maxCapacity="maxCapacity"
                            :currentCapacity="currentCapacity"
                            :boxQty="boxQty"
                            :productLimit="productLimit"
                            :addCopy="addCopy"
                            />
                        </li>
                        <p class="other-gifts" v-if="nonFilteredProducts.length > 0">All Other Gifts</p>
                        <li v-for="addonProduct in nonFilteredProducts" :key="addonProduct.id">
                            <AddonProductNew 
                            @loadmodal="openModal($event)" 
                            :product="addonProduct" 
                            :cartProducts="selectedAddonProducts"
                            :maxCapacity="maxCapacity"
                            :currentCapacity="currentCapacity"
                            :boxQty="boxQty"
                            :productLimit="productLimit"
                            :addCopy="addCopy"
                            />
                        </li>
                    </ul>
                </div>
                <SideCartNew 
                    v-show="isSticking" 
                    :isSticking="isSticking" 
                    :step="1"
                    @changepage="changePage($event)" 
                    @openmodal="openModal($event)"
                    @gostep="goStep($event)"
                />
            </div>
        </div>
        <SideCartNew 
            v-show="!isSticking" 
            :isSticking="isSticking" 
            @changepage="changePage($event)" 
            @openmodal="openModal($event)"
            @gostep="goStep($event)"
            :step="1" 
        />
        <AddonProductModal 
            v-if="showModal == true && currentSelectedAddon != null" 
            :selectedAddon="currentSelectedAddon"
            :addonProducts="modalProducts"
            :cartProducts="selectedAddonProducts"
            :recommendedProducts="modalRecommendedProducts"
            @closemodal="closeModal()"
            @changeselectedaddon="openModal($event)"
        >
        </AddonProductModal>
        <FiltersMobile :filteredPreAddons="filteredPreProducts" @closefilter="showFilters()" :isSticking="isSticking" v-if="filterIsShown" :filteredAddons="sortedProducts"/>
        <SortMobile @closefilter="showSort()" v-if="sortIsShown" :isSticking="isSticking"/>
    </div>
</template>
    
<script>
import Vue from 'vue'
import AddonProductNew from './AddonProductNew.vue';
import SideCartNew from './SideCartNew.vue'
import AddonProductModal from './AddonProductModal.vue'
import Filters from './Filters.vue'
import { mapGetters } from 'vuex';
import confetti from "canvas-confetti";
import AddonProductSkeleton from "./Skeletons/AddonProductSkeleton.vue"
import FiltersMobile from './Step2Mobile/FiltersMobile.vue'
import SortMobile from './Step2Mobile/SortMobile.vue'
import { AutoPlay, Arrow } from "@egjs/flicking-plugins";
import CategoriesFilter from './Filters/CategoriesFilter.vue';

export default {
    components: {
        AddonProductNew,
        SideCartNew,
        AddonProductModal,
        Filters,
        AddonProductSkeleton,
        FiltersMobile,
        SortMobile,
        CategoriesFilter
    },
    data() {
        return{
            selectedAddon: null,
            showModal: false,
            isAllItems: false,
            isSticking: false,
            isChanging: false,
            selectedSecondOccasion: null,
            filterIsShown: false,
            sortIsShown: false,
            bulkOpen: true,
            plugins1: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: false })],
        }
    },
    watch:{
        selectedCategories:{ 
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
        selectedFilters:{ 
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
        selectedOccasion:{ 
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
        selectedSort:{
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
        cartLength:{
            handler(val,oldVal){
                if(val > oldVal && oldVal < 5){
                    confetti({origin:{
                        x: this.x
                        ,y: this.y
                    }});
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'addonProducts',
            'selectedAddonProducts',
            'boxQty',
            'maxCapacity',
            'currentCapacity',
            'selectedSort',
            'rangePrice',
            'selectedCategories',
            'selectedFilters',
            'cartQty',
            'productLimit',
            'addCopy',
            'boxProducts',
            'defaulBoxName',
            'cartNames',
            'feeProduct',
            'cardProducts',
            'categories',
        ]),
        selectedOccasion: {
            get(){ return this.$store.state.selectedOccasion},
            set(value){
                this.$store.commit('setSelectedOccasion', value );
            }
        },
        totalCurrentFilters(){
            let total = this.selectedOccasion.length + this.selectedCategories.filter(x => x != 'View All').length + this.selectedFilters.length;
            return total
        },
        breadcrumbText(){
            if(this.showReco)
                return `All products`
            let text = "";
            if(this.selectedOccasion.length > 0)
                text += this.selectedOccasion.join(", ");
            else 
                text += "All products";

            if(!this.selectedCategories.includes("View All"))
                text += ` > ${this.selectedCategories.join(", ")}`
            return text;
        },
        cartLength(){
            return this.selectedAddonProducts.length;
        },
        showReco(){
            return this.selectedOccasion.length == 0 && this.selectedFilters.length == 0 && this.selectedCategories.includes("View All") && this.selectedSort == 1;
        },
        notFilter(){
            return this.selectedOccasion.length == 0 && this.selectedFilters.length == 0 &&  this.selectedCategories.includes("View All") && this.selectedSort == 1;
        },
        filteredPreProducts(){
            let filterAddons =  JSON.parse(JSON.stringify(this.addonProducts));
            //filter via occasion
            if(this.selectedOccasion.length > 0){
                filterAddons = filterAddons.filter(x => x.tags.some(y => this.selectedOccasion.some(z => y.includes(z))));
            }

            //Filter categories
            if(!this.selectedCategories.includes("View All"))
                filterAddons = filterAddons.filter(x => x.tags.some(y =>  this.selectedCategories.some(z => y.includes(z))));

            //remove brandable if sorting by inventory
            if(this.selectedSort == 6){
                filterAddons = filterAddons.filter(x => x.tags.every(y =>  !y.includes("Brandable Swag")));  
            }

            //Filter for each category
            for(let filter of this.selectedFilters){
                filterAddons = filterAddons.filter(x => filter.filters.some(y => x.tags.includes(y)));
            }

            //Exclude products
            let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
            if(excludeFilters.length > 0){
                let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                filterAddons = filterAddons.filter(x => !excludedTags.includes(x.id));
            }
            
            return filterAddons;
        },
        filteredProducts(){
            //Filter Price
            return this.filteredPreProducts.filter(x => ((x.variants[0].price-this.rangePrice.min)*(x.variants[0].price-this.rangePrice.max) <= 0));
        },
        nonFilteredProducts(){
            let ids = this.filteredProducts.map(x => x.id);
            let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
            if(excludeFilters.length > 0){
                let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                return this.addonProducts.filter(x => !ids.includes(x.id) && !excludedTags.includes(x.id));
            }
            return this.addonProducts.filter(x => !ids.includes(x.id));
        },
        sortedProducts(){
            var sortedProducts = JSON.parse(JSON.stringify(this.filteredProducts));
            switch(this.selectedSort){
                case "2":
                    sortedProducts.sort((a,b) => {
                        var aIsIncluded = a.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                        var bIsIncluded = b.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                        if(aIsIncluded == bIsIncluded){
                            return 0;
                        }
                        else if(aIsIncluded == true){
                            return -1;
                        }
                        else if(bIsIncluded == true){
                            return 1;
                        }
                    });
                    break
                case "3":
                    sortedProducts.sort((a,b) => {
                        var aIsIncluded = this.dateDiffInDays(new Date(a.published_at),new Date()) < 60;
                        var bIsIncluded = this.dateDiffInDays(new Date(b.published_at),new Date()) < 60;
                        if(aIsIncluded == bIsIncluded){
                            return 0;
                        }
                        else if(aIsIncluded == true){
                            return -1;
                        }
                        else if(bIsIncluded == true){
                            return 1;
                        }
                    })
                    break
                case "4":
                    sortedProducts.sort((a,b) => { return a.variants[0].price - b.variants[0].price});
                    break;
                case "5":
                    sortedProducts.sort((a,b) => { return b.variants[0].price - a.variants[0].price})
                    break;
                case "6":
                    sortedProducts.sort((a,b) => { 
                        return b.variants[0].true_inv - a.variants[0].true_inv;
                    });
                    break;
                default:
                    break;
            }

            //Filter onDemand Product
            sortedProducts = sortedProducts.filter((x) => {
                let inCart = this.selectedAddonProducts.find(y => y.id == x.id );
                if(inCart)
                    return true;
                let indexVariant =  x.variants.findIndex(x =>x.sku && x.sku.toLowerCase().includes("ondemand"));
                if(indexVariant > -1){
                    if(this.boxQty >= this.demandQtyMin(x)){
                        return true
                    }
                    else {
                        let indexNotDemand =  x.variants.findIndex(x => !x.sku.toLowerCase().includes("ondemand"));
                        return x.variants[indexNotDemand].inventory_quantity >= this.boxQty
                    }
                }

                return x.variants.some(y => y.inventory_quantity >= this.boxQty);
            })

            return sortedProducts;
        },
        currentSelectedAddon(){
            if(this.selectedAddon){
                return this.selectedAddon;
            }
            else if(this.addonProducts.length > 0){
                return this.addonProducts[0];
            }
            else
                return null
        },
        recoProducts(){
            let products = this.addonProducts.filter(x => x.tags.some(y => y.toLowerCase() == "builder_reco"))

            return products
        },
        isOtherOccasion(){
            return this.selectedOccasion.includes("View All");
        },
        currentOccassionImage(){
            return "https://cdn.shopify.com/s/files/1/1363/8433/files/unexpected.svg?v=1683559909";
        },
        currentOccassionImageSticky(){
            return "https://cdn.shopify.com/s/files/1/1363/8433/files/mobile_scroll_header.png?v=1721328828";
        },
        modalProducts(){
            var addonCartIds = this.selectedAddonProducts.map(x => x.id)
            return this.sortedProducts.filter(x => 
                ((this.maxCapacity > (this.currentCapacity + x.capacity)) 
                && (this.boxQty < x.variants[0].inventory_quantity))
                || addonCartIds.includes(x.id)
            )
        },
        modalRecommendedProducts(){
            var addonCartIds = this.selectedAddonProducts.map(x => x.id);
            if(this.filteredPreProducts.length > 0){
                let products = this.filteredPreProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude")));
                if(products.length > 0)
                    return products.sort((a,b) => a.capacity - b.capacity);
                
                return this.addonProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude"))).sort((a,b) => a.capacity - b.capacity);
            }
        },
    },
    methods: {
        showFilters(){
            this.filterIsShown = !this.filterIsShown;
        },
        showSort(){
            this.sortIsShown = !this.sortIsShown;
        },
        openModal(product){
            ga('send', {
                hitType: 'event',
                eventCategory: 'Build A Box',
                eventAction: 'Open Product',
                eventLabel: product.title
            });
            this.selectedAddon = product;
            this.showModal = true;
        },
        closeModal(){
            this.showModal = false;
        },
        changePage(increment){
            const header = document.querySelector('.site-header');
            if (header) header.style.display = 'block';
            this.$emit("changepage", increment);
        },
        dateDiffInDays(a, b) {
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            // Discard the time and time-zone information.
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        },
        demandQtyMin(addon){
            let demandQtymin = addon.tags.find(x => x.includes("DEMAND_QTYMIN"));
            if(demandQtymin){
                if(demandQtymin){
                    demandQtymin = demandQtymin.split("_");
                    demandQtymin = demandQtymin[demandQtymin.length - 1];

                    return  parseInt(demandQtymin);
                }
            }

            return 0;
        },
        leaveBuilder(){
            const header = document.querySelector('.site-header');
            if (header) header.style.display = 'block';
            this.$emit("leavebuilder");
        },
        openCart(){
            if (typeof window.openCartDrawer === 'function') {
                window.openCartDrawer()
            }
        },
        onMouseMove(e){
          this.x = e.clientX / window.innerWidth;
          this.y = e.clientY / window.innerHeight;
        },
        scrollHeader(){
            let container = document.getElementById("jump1");
            container.scrollIntoView();
        },
        goStep(step){
            this.$emit("gostep",step);
        },
        isMobile() {
            return this.windowWidth < 768;
        },
    },
    mounted(){
        window.addEventListener('mousemove', this.onMouseMove, false);
        const pageContainer = document.getElementById('PageContainer');
        const that = this;

        if (pageContainer) {
        pageContainer.addEventListener('scroll', () => {
            const heightCap = 70;
            const scrollTop = pageContainer.scrollTop;

            if (scrollTop > heightCap) {
            if (!that.isSticking && !that.isChanging) {
                that.isSticking = true;
                that.isChanging = true;
                pageContainer.scrollTop = scrollTop + 30;
                setTimeout(() => {
                that.isChanging = false;
                }, 200);
            }
            } else {
            if (that.isSticking && !that.isChanging) {
                that.isSticking = false;
                that.isChanging = true;
                setTimeout(() => {
                that.isChanging = false;
                }, 200);
            }
            }
        });
        }
    },
    beforeDestroy(){
    }
}
</script>
<style>
@media screen and (min-width: 768px) {
#PageContainer{
    overflow-y: scroll;
    font-size: 0;
    height: 100vh;
}
}

.main-content,.BuildABox{
	display: inline !important;
	font-size: 0;
}
</style>
<style scoped>

.header-container{
    position: sticky;
    top: 0px;
    left: 0px;
    background-color: white;
    z-index: 4;
    width: 100%;
    padding: 0% 10%;
}

.header-container.cart{
    padding: 0 10px 0 10vw;
}

.header-container.sticky.cart{
    padding: 0 10vw;
}
.header-container.sticky{
    box-shadow: -2px 0px 1px 2px rgba(0,0,0,0.2);
    background-color: #eaf2ff;
}

.header-container.sticky .placeholder-recommendations{
    background-color: #eaf2ff;
}

.step2-container{
    width: 100%;
    display: flex;
}

.main-content-container{
    min-width: 90%;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
}

.main-content-container .content-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    position: relative;
    justify-content: flex-start;
    padding-top: 1%;
}

 .separator{
    width: 96%;
    border-bottom: 1px solid #E5E7EB;
    margin: 2% 0% 0% 2%;
}

.placeholder-recommendations{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    background-color: white;
    align-items: center;
    min-height: 45px;
}

.placeholder-recommendations img{
    width: 100%;
    padding: 1% 10%;
}

.leave-builder,.breadcrumb{
    font-size: 1.15vw;
    line-height: 1.5;
    letter-spacing: .08em;
    text-transform: uppercase;
    font-weight: 700;
    text-align: center;
    display: flex;
    align-items: center;
    flex: 2;
    z-index: 1;
    cursor: pointer;
}

.header-container.sticky .buttons-container .sort-block{
    display: none;
}

.header-container .buttons-container .sort-block{
    background-color: #ffebe0;
    border: 1px solid gray;
    font-size: 1vw;
    border-radius: 8px;
    text-align: center;
    padding: 0.5rem 1rem;
    position: absolute;
    right: 20%;
    top: -180%;
    line-height: 1.2;
}

.header-container .buttons-container .sort-block .close{
    position: absolute;
    border-radius: 50%;
    background-color: #fff;
    line-height: 1;
    border: 1px solid gray;
    aspect-ratio: 1;
    font-size: 0.8rem;
    width: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -.5rem;
    right: -.5rem;
}

.header-container .buttons-container .sort-block .arrow-t {
    width: 0;
    height: 0;
    border-top: 10px solid gray;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    position: absolute;
    bottom: -10px;
    left: 42%;
}

.header-container .buttons-container .sort-block .arrow-t .inner {
    position: relative;
    top: -11px;
    right: 6px;
    width: 0;
    height: 0;
    border-top: 9.5px solid #ffebe0;
    border-right: 6.5px solid transparent;
    border-left: 6.5px solid transparent;
}

.header-container .buttons-container{
    display: flex;
    gap: 5%;
    flex: 2;
    position: relative;
}

.header-container .buttons-container button{
    display: flex;
    gap: 5px;
    align-items: center;
    padding: 1% 3%;
    font-size: 1.1vw;
}

.header-container .buttons-container button.selected{
    color: #a01adb;
    font-weight: 700;
    border: 1px solid #a01adb;
}

.header-container .buttons-container button.selected span{
    color: #a01adb;
    font-weight: 700;
}

.header-container .buttons-container button img{
    width: 15px;
    padding: unset
}

.leave-builder{
    justify-content: flex-end;
    gap: 5px;
}

.leave-builder span{
    line-height: 0;
}

.leave-builder img{
    width: 15px;
    padding: unset;
}

.sticky-image-container{
    flex: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.sticky .sticky-image-container .steps{
    display: flex;
}

.sticky-image-container .steps{
    width: 100%;
    font-size: 1vw;
    letter-spacing: .08em;
    line-height: 1.5;
    font-weight: 700;
    text-align: center;
    display: none;
    align-items: center;
    justify-content: center;
}

.sticky-image-container .steps .legend{
    margin: 0 0.5rem;
    letter-spacing: 0;
}

.sticky-image-container .steps .dot{
    display: flex;
    align-items: center;
    padding: 0.5%;
    border-radius: 50%;
    margin: 0% 0.5%;
}

.sticky-image-container .steps .dot.current{
    background-color: #f5eefe;
}

.sticky-image-container .steps .dot span{
    height: 0.65vw;
    width: 0.65vw;
    background-color: black;
    border-radius: 50%;
    display: inline-block;
    opacity: 0.5;
}

.sticky-image-container .steps .dot span.selected{
    opacity: 1;
}

.categories-container{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.categories-container div{
    display: flex;
}

.categories-container button{
    margin: 0% 1%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2vw;
    line-height: 1.3;
    color: #0F0C38;
}

.categories-container button.selected{
    font-weight: bold;
    border-bottom: 1px solid #0F0C38;
    padding-bottom: 1%;
}

.filters-container{
    width: 15%;
    padding: 0% 1%;
}

.filters-container .sticky-filter{
    width: 100%;
    position: sticky;
    top: 50px;
}

.filters-container .title{
    font-size: 1.3vw;
    font-weight: bold;
}

.products-wrapper{
    width: 100%;
    padding: 0 10% 0 0%;
    overflow-x: hidden;
}

.products-wrapper.big{
    width: 100%;
    padding: 0 1vw 0 0;
}

.products-wrapper .mini-header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 1rem;
}

.mini-header .product-sort, .mini-header .sticky-image-container{
    flex: 1;
}

.products-container{
    width: 100%;
    height: fit-content;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    gap: 2.66%;
}

.products-container li{
    width: 23%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 2rem; 
}

.recommended-product-container{
    width: 85%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-between;
    overflow-y: scroll;
    padding-top: 2%;
    padding-left: 2%;
}

.category-products-container{
    width: 100%;
}

.category-products-container .category-title{
    padding-left: 2.5%;
    font-family: 'Moret';
    font-size: 1.8vw;
    line-height: 1.23;
    letter-spacing: 0.03em;
    color: #0F0C38;
    padding-bottom: 2%;
}

.category-products-container .products-container{
    width: 100%;
    padding: 0% 2.5%;
    margin: 0;
}

.view-all-products-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    position: relative;
}

.view-all-products-container .main-image{
    width: 100%;
}

.view-all-products-container .small-arrow{
    width: 10%;
    position: absolute;
    bottom: 5%;
}

.sort-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: white;
}

.product-sort{
    display: flex;
    width: 25%;
    align-items: center;
    justify-content: center;
    gap: 5%;
}

.product-sort span{
    font-weight: bold;
    font-size: 1.1vw;
    line-height: 1.3;
    color: #0F0C38;
}

.product-sort select{
    width: auto;
    padding: 2% 15% 2% 2%;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    border-radius: 100px;
    font-size: 0.8vw;
    line-height: 1.3;
    color: #0F0C38;
    height: unset;
}

.other-gifts{
    width: 100%;
    font-family: Karla, sans-serif;
    text-transform: capitalize;
    font-size: 1.5vw;
    margin-bottom: 1rem;
    font-weight: bold;
}

.other-gifts.recommended{
    margin-left: calc(10vw - 1rem);
    width: auto;
    margin-bottom: 0;
}

.cartNumber {
    top: -40%;
    right: -2%;
    position: absolute;
    background-color: #FFE245;
    border-radius: 50%;
    height: 16px;
    width: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cartNumber span {
    color: #0B3245;
    font-weight: bold;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
}

.content-header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2% 10%;
    position: relative;
    scroll-margin: 70px;
    gap: 10px;
    margin-bottom: 1rem;
    border-top: 1px solid #C8CCD2;
    border-bottom: 1px solid #C8CCD2;
}


.content-header > div{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.content-header .title{
    font-size: 3.5vw;
    line-height: 1;
    font-family: Founders Grotesk, sans-serif;
    margin: unset;
}

.content-header .subtitle{
    display: flex;
    font-size: 1.3vw;
    align-items: center;
    gap: 5px;
}

.content-header .starburst{
    width: 6%;
    transform: rotate(-10deg);
}

.content-header .sticky-image-container{
    width: 100%;
}

.content-header .sticky-image-container .steps{
    display: flex;
}

    .flicking-container{
        margin-right: 1rem;
    }

    .recommended-flicker{
        width: 100%;
        background-color: #EDF9EB;
        padding: 2% 5% 0;
        margin-bottom: 2rem;
    }

    .flicker-wrapper{
        width: 99vw;
        margin-left: -10vw;
        position: relative;
    }

    .flicker-wrapper.small{
        width: 89vw;
    }
</style>